export default (name = '', size = 60, textColor = '#fff', backColor = '#000') => {
	const nameSplit = String(name).toUpperCase().split(' ');
	let initials;
	let canvas;

	if (nameSplit.length === 1) {
		initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
	}
	else {
		initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
	}

	if (window.devicePixelRatio) {
		// eslint-disable-next-line no-param-reassign
		size *= window.devicePixelRatio;
	}

	canvas = document.createElement('canvas');
	canvas.width = size;
	canvas.height = size;
	const context = canvas.getContext('2d');

	context.fillStyle = backColor;
	context.fillRect(0, 0, canvas.width, canvas.height);
	context.font = `${Math.round(canvas.width / 2)}px Arial`;
	context.textAlign = 'center';
	context.fillStyle = textColor;
	context.fillText(initials, size / 2, size / 1.5);

	const dataURI = canvas.toDataURL();
	canvas = null;

	return dataURI;
};
